import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { CSSTransition } from "react-transition-group";
import SimpleBar from "simplebar-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  // faSignOutAlt,
  faTimes,
  faThumbtack,
  faDoorClosed,
  faMoneyCheck,
  faDatabase,
  faEnvelopeOpen,
  faFlask,
  faCashRegister,
  faPoll,
  faReceipt,
  faUsersCog,
  faBlog,
} from "@fortawesome/free-solid-svg-icons";
import {
  // Image,
  // Button,
  Nav,
  Accordion,
  Navbar,
} from "@themesberg/react-bootstrap";

import { router } from "../../../routes";
import { UserContext } from "../../../utils/ProtectedRoute";
import { Link } from "react-router-dom";

const CollapsableNavItem = (props) => {
  const { title, icon, eventKey, children = null } = props;
  const { pathname } = useLocation();

  const defaultKey = pathname.split("/")[1];

  return (
    <Accordion as={Nav.Item} defaultActiveKey={defaultKey}>
      <Accordion.Item eventKey={eventKey}>
        <Accordion.Button
          as={Nav.Link}
          className="d-flex justify-content-between align-items-center"
        >
          <span>
            <span className="sidebar-icon">
              <FontAwesomeIcon icon={icon} />
            </span>
            <span className="sidebar-text">{title}</span>
          </span>
        </Accordion.Button>
        <Accordion.Body className="multi-level">
          <Nav className="flex-column">{children}</Nav>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

const NavItem = (props) => {
  const { icon, link, title } = props;
  const { pathname } = useLocation();

  return (
    <Nav.Item className={pathname === link ? "active" : ""}>
      <Nav.Link as={Link} to={link}>
        <span>
          {!icon ? null : (
            <span className="sidebar-icon">
              <FontAwesomeIcon icon={icon} />
            </span>
          )}

          <span className="sidebar-text">{title}</span>
        </span>
      </Nav.Link>
    </Nav.Item>
  );
};

const SideBar = ({ handleLogout, setHandleNavbar, handleNavbar }) => {
  // get user data from context to validate which menu has shown and hide
  // for the current user
  const { userData } = useContext(UserContext);
  // contains sidebar menu
  const [sideMenu, setSideMenu] = useState([]);

  const menuStaff = [
    {
      title: "Pembayaran VA",
      icon: faMoneyCheck,
      eventKey: "va",
      children: [
        {
          title: "Overview",
          link: router.OverviewPembayaranVA.path,
        },
        {
          title: "Transaction",
          link: router.ListPembayaranVA.path,
        },
        {
          title: "Report",
          link: router.ReportPembayaranVA.path,
        },
      ],
    },
    {
      title: "Permohonan Surat",
      icon: faEnvelopeOpen,
      eventKey: "permohonan",
      children: [
        {
          title: "Overview",
          link: router.OverviewPermohonan.path,
        },
        {
          title: "Transaction",
          link: router.ListPermohonan.path,
        },
        {
          title: "Report",
          link: router.ReportPermohonan.path,
        },
      ],
    },
    {
      title: "Praktikum",
      icon: faFlask,
      eventKey: "praktikum",
      children: [
        {
          title: "Overview",
          link: router.OverviewPraktikum.path,
        },
        {
          title: "Transaction",
          link: router.ListPraktikum.path,
        },
        {
          title: "Report",
          link: router.ReportPraktikum.path,
        },
      ],
    }
  ];

  // on init
  useEffect(() => {
    // ADMIN
    if (userData?.id_role === "HA01") {
      setSideMenu([
        {
          title: "SILANG",
          icon: faThumbtack,
          link: "/dashboard",
        },
        {
          title: "Config",
          icon: faUsersCog,
          eventKey: "config",
          children: [
            {
              title: "Semester",
              link: router.ViewConfigSemester.path,
            },
          ],
        },
        {
          title: "Master",
          icon: faDatabase,
          eventKey: "master",
          children: [
            {
              title: "Fakultas",
              link: router.ListFakultas.path,
            },
            {
              title: "Prodi",
              link: router.ListProdi.path,
            },
            {
              title: "Role",
              link: router.ListRole.path,
            },
            {
              title: "Layanan",
              link: router.ListLayanan.path,
            },
            {
              title: "Jenis Pembiayaan",
              link: router.ListJenisPembiayaan.path,
            },
            {
              title: "Dokumen",
              link: router.ListDokumen.path,
            },
            {
              title: "Kode Payment VA",
              link: router.ListKodepayment.path,
            },
            {
              title: "Survey",
              link: router.ListSurvey.path,
            },
            {
              title: "User",
              link: router.ListUser.path,
            },
            {
              title: "Staff Menu",
              link: router.ListStaffMenu.path,
            },
            {
              title: "User Discount",
              link: router.ListUserDiscount.path,
            },
          ],
        },
        {
          title: "Mading",
          icon: faBlog,
          link: router.ListMading.path,
        },
      ]);
    }
    // DEKAN/WADEK/TU
    else if (userData?.id_role !== "HA05") {
      const listMenu = [
        {
          title: "SILANG",
          icon: faThumbtack,
          link: "/dashboard",
        },
      ];
      if (userData?.id_role === "HA02") {
        listMenu.push(
          ...[
            {
              title: "Cashflow",
              icon: faCashRegister,
              eventKey: "cashflow",
              children: [
                {
                  title: "Overview",
                  link: router.OverviewCashflow.path,
                },
                {
                  title: "Transaction",
                  link: router.ListCashflow.path,
                },
                {
                  title: "Report",
                  link: router.ReportCashflow.path,
                },
              ],
            },
            {
              title: "Mutasi Bank",
              icon: faReceipt,
              link: router.ListImportMutasiBank.path,
            },
          ]
        );
      } else {
        listMenu.push(
          ...[
            // pengecekan hak akses untuk staff
            ...(userData?.staff_menu ? 
              menuStaff.filter(e => userData?.staff_menu?.some(e2 => e2 == e.eventKey)) : menuStaff
            ),
            {
              title: "Survey User",
              icon: faPoll,
              eventKey: "survey",
              children: [
                {
                  title: "Overview",
                  link: router.OverviewSurveyUser.path,
                },
                {
                  title: "Transaction",
                  link: router.ListSurveyUser.path,
                },
              ],
            },
          ]
        );
      }
      setSideMenu(listMenu);
    }
    // MAHASISWA
    else {
      setSideMenu([
        {
          title: "SILANG",
          icon: faThumbtack,
          link: "/dashboard",
        },
        {
          title: "Pembayaran VA",
          icon: faMoneyCheck,
          link: router.ListPembayaranVA.path,
        },
        {
          title: "Permohonan Surat",
          icon: faEnvelopeOpen,
          link: router.ListPermohonan.path,
        },
        {
          title: "Praktikum",
          icon: faFlask,
          link: router.ListPraktikum.path,
        },
      ]);
    }
  }, [userData]);

  return (
    <>
      <Navbar
        expand={false}
        collapseOnSelect
        variant="dark"
        className="navbar-theme-primary px-4 d-md-none"
      >
        <Navbar.Brand className="me-lg-5">SILANG</Navbar.Brand>
        <Navbar.Toggle onClick={() => setHandleNavbar(!handleNavbar)}>
          <span className="navbar-toggler-icon" />
        </Navbar.Toggle>
      </Navbar>
      <CSSTransition timeout={300} classNames="sidebar-transition">
        <SimpleBar
          className={`collapse ${
            handleNavbar ? "show" : ""
          } sidebar d-md-block bg-primary text-white`}
        >
          <div className="sidebar-inner px-4 pt-3">
            <div className="user-card d-flex d-md-none align-items-center justify-content-between justify-content-md-center pb-4">
              <div className="d-flex align-items-center">
                {/* <div className="user-avatar lg-avatar me-4">
                  <Image className="card-img-top rounded-circle border-white" />
                </div> */}
                <div className="d-block">
                  <h6>Hi, {userData?.nama}</h6>
                </div>
              </div>
              <Nav.Link
                className="collapse-close d-md-none"
                onClick={() => setHandleNavbar(!handleNavbar)}
              >
                <FontAwesomeIcon icon={faTimes} />
              </Nav.Link>
            </div>
            {/* List of Sidebar Menu Starts Here */}
            <Nav className="flex-column pt-3 pt-md-0">
              {sideMenu?.map((item, i) =>
                item?.children ? (
                  <CollapsableNavItem
                    key={i}
                    title={item.title}
                    icon={item.icon}
                    eventKey={item.eventKey}
                  >
                    {item?.children?.map((itemChild, idx) => (
                      <NavItem
                        key={idx}
                        title={itemChild.title}
                        link={itemChild.link}
                      />
                    ))}
                  </CollapsableNavItem>
                ) : (
                  <NavItem
                    key={i}
                    title={item.title}
                    icon={item.icon}
                    link={item.link}
                  />
                )
              )}
              {/* logout button */}
              <Nav.Item>
                <Nav.Link>
                  <span onClick={handleLogout}>
                    <span className="sidebar-icon">
                      <FontAwesomeIcon icon={faDoorClosed} />
                    </span>
                    <span className="sidebar-text">Logout</span>
                  </span>
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
        </SimpleBar>
      </CSSTransition>
    </>
  );
};

export default SideBar;
